<template>
<div class="chapter">
<div class="inner_page">
<p class="crt" id="d6e565">Copyright © 2006 by Rebecca Pawel </p>
<p class="crt" id="d6e655">All rights reserved.</p>
<p class="crt" id="d6e705">Published by<br/>Soho Press, Inc.<br/>853 Broadway<br/>New York, NY 10003 </p>
<p class="crt" id="d6e855">Library of Congress Cataloging-in-Publication Data </p>
<p class="crt" id="d6e885">Pawel, Rebecca, 1977–<br/>The summer snow / Rebecca Pawel<br/>p. cm.</p>
<p class="crt" id="d6e1055">ISBN–10: 1-56947-408-7<br/>ISBN–13: 978-1-56947-408-2<br/>1. Tejada Alonso y Lâón, Carlos (Fictitious character)—Fiction. 2. Older women—Crimes against—Fiction. 3. Granada (Spain: Province)—Fiction. 4. Aunts—Crimes against—Fiction. 5. Police—Spain—Fiction. I. Title.</p>
<p class="crt" id="d6e1335">PS3616.A957S86 2006<br/>813'.6–dc22        2005051584 </p>
<p class="crt" id="d6e1465">10 9 8 7 6 5 4 3 2 1 </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Pawe_9781569477786_epub_c5_r1.vue?8c7a5986